'use client';

import CareersBenefits from './_components/CareersBenefits';
import CareersGallery from './_components/CareersGallery';
import CareersIntro from './_components/CareersIntro';
import CareersJobBoard from './_components/CareersJobBoard';
import CareersOuttro from './_components/CareersOutro';
import CareersTestimonials from './_components/CareersTestimonials';

const Content = () => {
  return (
    <div data-cy="careers-content">
      <CareersIntro />
      <CareersTestimonials />
      <CareersBenefits />
      <CareersGallery />
      <CareersJobBoard />
      <CareersOuttro />
    </div>
  );
};

export default Content;
